const queryBuilder = (index, fieldName, value) => {
  const operator = index > 0 ? "&" : "";
  return value || value === 0
    ? operator + fieldName + "=" + value.toString()
    : "";
};

export const builder = (query = {}) => {
  let temp = "";
  if (query.name === "") {
    delete query.name;
  }
  Object.keys(query).forEach((key, i) => {
    temp += queryBuilder(i, key, query[key]);
  });
  return "?" + temp;
};
